import $ from 'jquery';

const $acfBanner = $('.acf-banner');
const style = $acfBanner.data('links');

$acfBanner.find('a:not(.acf-banner-button)').addClass(style);
